import React from 'react';
import { Link } from 'react-router-dom';
import './App.css';

function Home() {
  return (
    <main className="page">
      <section className="hero">
        <p className="eyebrow">Currency Companion</p>
        <h1>Stay on top of exchange rates in a clean, simple view.</h1>
        <p>
          Track the latest currency highlights, browse a polished dashboard,
          and jump into your exchange rate view whenever you need it.
        </p>
        <div className="hero-actions">
          <Link className="primary-btn" to="/currency">
            Open Currency View
          </Link>
          <a className="secondary-btn" href="#features">
            Explore Features
          </a>
        </div>
      </section>

      <section id="features" className="feature-grid">
        <article className="card">
          <h3>Live Snapshot</h3>
          <p>See the main currency movements at a glance.</p>
        </article>
        <article className="card">
          <h3>Easy Navigation</h3>
          <p>Switch between the home and currency pages with ease.</p>
        </article>
        <article className="card">
          <h3>Modern Layout</h3>
          <p>Enjoy a calm, focused interface built for quick reading.</p>
        </article>
      </section>
    </main>
  );
}

export function CurrencyPage() {
  return (
    <main className="page">
      <section className="hero">
        <p className="eyebrow">Currency Page</p>
        <h2>Exchange rates at a glance</h2>
        <p>Here is a simple placeholder for your currency experience.</p>
        <div className="currency-box">
          <div>
            <strong>USD</strong>
            <span>1.00</span>
          </div>
          <div>
            <strong>EUR</strong>
            <span>0.92</span>
          </div>
          <div>
            <strong>GBP</strong>
            <span>0.79</span>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Home;
